<div class="wallet-container">

  <div class="back-and-payment-method">
    <div class="selected-payment-method flex justify-center sm:justify-center items-center round-border-normal mt-4 sm:mr-0 sm:mt-8">
      <span class="wpx-200 hpx-125 sm:wpx-250 sm:hpx-150 background-cover rounded-md bg-cover flex justify-center items-center">
        <img class="w-full" [src]="paymentMethodImg">
      </span>
    </div>
  </div>

  <div class="flex flex-wrap bg-gray-300 sm:pb-6 sm:ml-12 ml-4 sm:mr-12 mr-4 mb-3 mt-16" style="border-radius: 12px;" [ngClass]="loading ? 'sm:pt-6' : 'sm:pt-0'">
    <div class="container">
      <mat-spinner
        *ngIf="loading"
        class="loading-spinner"
        [color]="color"
        [diameter]="diameter"
      >
      </mat-spinner>
    </div>
    <router-outlet></router-outlet>
  </div>

  <div class="flex flex-wrap flex-col items-center justify-center mb-12 mt-8 " [ngClass]="mobile ? 'pb-3' : 'pb-0' ">
    <button [disabled]="loading" mat-raised-button class="text-xl font-medium rounded-lg flex items-center flex justify-center  " [ngClass]="mobile ? 'w-1/2' : 'w-1/4' " [ngStyle]="{'height': '48px', 'color': 'black',  'border': '3px solid ' + headerColor }" mat-button (click)="cancelTransaction()">
      <p class="p-0 m-0">CANCEL</p>
    </button>
  </div>


  <div class="bottom-container w-full flex flex-row items-end pl-0 pr-0 sm:pl-2 sm:pr-2 pb-0 justify-between absolute bottom-0 mat-typography">
    <p class="text-md sm:text-lg ml-2 text-gray-800 mb-2">This is a secure transaction</p>
    <img *ngIf="!hidePgLogo" class="sm:h-14 h-12 mr-2 mb-0 sm:mr-2 sm:mb-1" src="assets/icons/Icons/Group.png">
  </div>

</div>
